// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1gvMR","Success":"Button_Success__72-8V","Danger":"Button_Danger__1NULK"};